import { ReactNode } from 'react'

const STEPS = ['Upload Your Menu', 'Refine Your Contents', 'Copy the Code', 'Add to Your Website']

/** Right half of the landing screen: welcome text and the four steps */
export const WelcomeContent = () => (
  <div className="w-full">
    <h1 className="landing-welcome-to mb-0">Welcome to</h1>
    <h1 style={{ fontWeight: 'bold' }} className="landing-text-to-table mb-6">
      Text to Table
    </h1>

    <p className="landing-description mb-8 max-w-md">
      Convert your menu PDF or photo into a digital, on-brand HTML embed for your website.
    </p>

    <div className="space-y-4">
      {STEPS.map((step, index) => (
        <div key={step} className="flex items-center space-x-3">
          <div
            className="w-8 h-8 border rounded-full flex items-center justify-center text-brand-primary font-medium bg-transparent"
            style={{ borderColor: 'var(--color-brand-primary)' }}
          >
            {index + 1}
          </div>
          <span className="landing-list-item">{step}</span>
        </div>
      ))}
    </div>
  </div>
)

export const RightPanel = ({ children }: { children: ReactNode }) => (
  <div style={{ paddingLeft: '100px', paddingRight: '100px' }} className="w-1/2 bg-stone-100 flex items-center p-8">
    {children}
  </div>
)
